import { PropsType } from "./Links.props"
import { StyleForLink } from './Link.presents'

export const LinkBtn = (props: PropsType) => {
  return <StyleForLink onClick={props.onClick} to={props.path} {...props}>{props.text}</StyleForLink>
}